import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import './App.scss';
import './styles/_breakpoint.scss';
import { useContext, useEffect, useState } from 'react';
import { OrderDetailsContext } from './context/OrderDetailsContext';

// Components
import Footer from './components/Footer/Footer';

// Pages
import ExpressTrackerPage from './pages/ExpressTrackerPage';
import ErrorPage from './pages/ErrorPage';
import SlottedPage from './pages/SlottedPage';
import Offline from './components/Offline/Offline';
import logoGif from './assets/logo.gif';

const App = () => {
  // getting the value if user is online or offline
  const [offline, setOffline] = useState('');

  useEffect(() => {
    if (navigator.onLine) {
      setOffline('online');
    } else {
      setOffline('offline');
    }

    window.addEventListener('offline', function (e) {
      setOffline('offline');
    });

    window.addEventListener('online', function (e) {
      setOffline('online');
    });
  }, []);

  // Getting error details
  const { slottedOrder } = useContext(OrderDetailsContext);
  const { isError } = useContext(OrderDetailsContext);
  const { loading } = useContext(OrderDetailsContext);

  // user current page location
  var currentLocation = window.location.pathname;
  const orderId = currentLocation.replace('/order/', '');

  return (
    <Router>
      <>
        {offline === 'offline' && <Offline />}

        {offline === 'online' && (
          <>
            {loading === 'yes' ? (
              // <div className="loader">Loading...</div>

              <div className="logo-wrapper">
                <div className="logGif">
                  <img src={logoGif} alt="Nandus Loading..." />
                </div>
              </div>
            ) : (
              <div className="page-wrapper">
                <Switch>
                  <Route exact path={`/order/:${orderId}`}>
                    {isError === 'yes' ? (
                      <ErrorPage />
                    ) : (
                      <>
                        {slottedOrder === 'yes' ? (
                          <SlottedPage />
                        ) : (
                          <ExpressTrackerPage />
                        )}
                      </>
                    )}
                  </Route>
                  <Route exact path="*">
                    <ErrorPage />
                  </Route>
                </Switch>
                <Footer />
              </div>
            )}
          </>
        )}
      </>
    </Router>
  );
};

export default App;
